import React from 'react';
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, AreaChart } from 'recharts';

const EquipmentLifecycleChart = ({ data }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg shadow-lg p-4">
          <p className="text-sm font-semibold text-foreground mb-2">Tahun {payload?.[0]?.payload?.year}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 mb-1">
              <div className="flex items-center gap-2">
                <div 
                  className="w-3 h-3 rounded-full" 
                  style={{ backgroundColor: entry?.color }}
                />
                <span className="text-xs text-muted-foreground">{entry?.name}:</span>
              </div>
              <span className="text-sm font-medium text-foreground data-text">
                {entry?.value}%
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-80 md:h-96" aria-label="Equipment Lifecycle Area Chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
          <defs>
            <linearGradient id="colorPerformance" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="var(--color-primary)" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="var(--color-primary)" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="colorMaintenance" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="var(--color-warning)" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="var(--color-warning)" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis 
            dataKey="year" 
            tick={{ fill: 'var(--color-foreground)', fontSize: 12 }}
            label={{ 
              value: 'Tahun Operasi', 
              position: 'insideBottom', 
              offset: -10,
              style: { fill: 'var(--color-foreground)', fontSize: 14 }
            }}
          />
          <YAxis 
            tick={{ fill: 'var(--color-foreground)', fontSize: 12 }}
            label={{ 
              value: 'Persentase (%)', 
              angle: -90, 
              position: 'insideLeft',
              style: { fill: 'var(--color-foreground)', fontSize: 14 }
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            wrapperStyle={{ paddingTop: '20px' }}
            iconType="circle"
          />
          <Area
            type="monotone"
            dataKey="performance"
            name="Performa"
            stroke="var(--color-primary)"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorPerformance)"
          />
          <Area
            type="monotone"
            dataKey="maintenanceCost"
            name="Biaya Pemeliharaan"
            stroke="var(--color-warning)"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorMaintenance)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EquipmentLifecycleChart;